import entitySlice from './entitySlice';

export { default as entityOp } from './operations';

export default entitySlice;
